import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initTrainingModes(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TRAINING_MODES_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/training_mode`, {
          withCredentials: true,
        })
        .then(response => [...response.data]),
  );
}
